// extracted by mini-css-extract-plugin
export default {"cookiesContainer":"Cookies_cookiesContainer__3zjeV","cookiesTitle":"Cookies_cookiesTitle__mCDd+"};